import { render } from "./submenu.vue?vue&type=template&id=062e458c"
import script from "./submenu.vue?vue&type=script&lang=js"
export * from "./submenu.vue?vue&type=script&lang=js"
script.render = render

export default script